<template>
	<div class="custom-field-file">
		<!-- 上传按钮状态 -->
		<el-upload
			v-if="showFileList.length === 0"
			action="#"
			:accept="formatUploadExt"
			:http-request="uploadFile"
			:show-file-list="false"
			:before-upload="beforeFileUpload"
			:disabled="uploading"
		>
			<el-link type="primary" :disabled="uploading" class="upload-link">
				<i v-if="uploading" class="el-icon-loading"></i>
				<span>{{ $t('enterprise.field.upload') }}</span>
			</el-link>
		</el-upload>

		<!-- 文件显示状态 -->
		<template v-else>
			<div v-for="file in showFileList" :key="file.url" class="file-display">
				<span class="file-name text-overflow" @click="handlePreview(file)">{{ file.fileName }}</span>
				<el-link type="danger" @click="handleDelete(file)">{{ $t('enterprise.field.delete') }}</el-link>
			</div>
		</template>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useFileUpload } from './useFileUpload';

const props = defineProps({
	field: {
		type: Object,
		required: true
	}
});

const emits = defineEmits(['update']);

const internalFileList = ref([]);
const showFileList = computed(() => {
	return internalFileList.value.filter(item => item.url);
});

const initFileInfo = () => {
	const value = props.field?.dynamicFieldValue;
	if (!value) {
		internalFileList.value = [];
		return;
	}
	try {
		internalFileList.value = JSON.parse(value);
	} catch {
		internalFileList.value = [];
	}
};
initFileInfo();

const onUploadFile = data => {
	const info = {
		url: data.viewurl,
		fileName: data.name
	};
	internalFileList.value.push(info);
	updateParent();
};

const handleDelete = file => {
	internalFileList.value = internalFileList.value.filter(item => item.url !== file.url);
	updateParent();
};

const handlePreview = file => {
	if (file.url) {
		window.open(file.url);
	}
};

const updateParent = () => {
	const list = internalFileList.value
		.filter(item => item.url)
		.map(item => ({
			url: item.url,
			fileName: item.fileName
		}));
	emits('update', JSON.stringify(list));
};

const { beforeFileUpload, uploadFile, formatUploadExt, uploading } = useFileUpload({
	limit: 200,
	onUpload: onUploadFile
});
</script>

<style lang="less" scoped>
.custom-field-file {
	.file-display {
		display: inline-flex;
		align-items: center;
		gap: 2px;

		.file-name {
			cursor: pointer;
			color: #3964e5;
			font-size: 14px;
			font-weight: 400;
			line-height: 18px;
			text-decoration: underline;
			max-width: 260px;
		}
	}

	.upload-link {
		display: inline-flex;
		align-items: center;
		gap: 4px;

		.el-icon-loading {
			font-size: 14px;
		}
	}

	/deep/ .el-link {
		vertical-align: baseline;
	}
}
</style>
